import type { ReactNode } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { cn } from './lib/cn';

export type StatTileProps = {
  label: string;
  value: ReactNode;
  delta?: { value: string; positive?: boolean };
  icon?: ReactNode;
  sub?: ReactNode;
  className?: string;
};

export function StatTile({
  label,
  value,
  delta,
  icon,
  sub,
  className,
}: StatTileProps) {
  return (
    <div
      className={cn(
        'rounded-2xl bg-card border border-border p-5 shadow-ui-sm hover:shadow-ui-md transition-shadow',
        className
      )}
    >
      <div className='flex items-start justify-between gap-3'>
        <div className='text-sm font-medium text-muted-foreground'>{label}</div>
        {icon && (
          <div className='grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand-navy-100 text-brand-navy'>
            {icon}
          </div>
        )}
      </div>
      <div className='mt-3 flex items-baseline gap-2'>
        <div className='tabular-nums text-2xl font-bold text-brand-navy sm:text-3xl'>
          {value}
        </div>
        {delta && (
          <span
            className={cn(
              'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold',
              delta.positive
                ? 'bg-emerald-100 text-emerald-700'
                : 'bg-red-100 text-red-700'
            )}
          >
            {delta.positive ? (
              <TrendingUp className='h-3 w-3' />
            ) : (
              <TrendingDown className='h-3 w-3' />
            )}
            {delta.value}
          </span>
        )}
      </div>
      {sub && <div className='mt-2 text-sm text-muted-foreground'>{sub}</div>}
    </div>
  );
}
